import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FiChevronLeft, FiChevronRight, FiArrowRight } from 'react-icons/fi';

const slides = [
  {
    id: 1,
    image: '/images/image.png', // You'll need to add these images to your public folder
    title: 'Bride-to-be celebration',
    subtitle: 'Host a memorable bridal shower or bachelorette party with a private screening, custom themes, decorations, and entertainment await you and your closest friends.',
    link: '/branches',
    buttonText: 'Book Now'
  },
  // {
  //   id: 2,
  //   image: '/images/image2.png',
  //   title: 'Proposal night',
  //   subtitle: 'Create an unforgettable proposal moment in our romantic setting with customized decorations, private dining, and special arrangements for your perfect evening.',
  //   link: '/branches',
  //   buttonText: 'Plan Proposal'
  // },
  // {
  //   id: 3,
  //   image: '/images/image3.png',
  //   title: 'Romantic date',
  //   subtitle: 'Experience an intimate evening with your special someone in our beautifully themed private spaces with personalized service and gourmet dining.',
  //   link: '/branches',
  //   buttonText: 'Book Date Night'
  // },
  {
    id: 2,
    image: '/images/image4.jpeg',
    title: 'Birthday celebration',
    subtitle: 'Make your birthday extraordinary with themed decorations, custom cake arrangements, and entertainment options in a private party space.',
    link: '/branches',
    buttonText: 'Book Now'
  },
  {
    id: 3,
    image: '/gallery/image.jpg',
    title: 'Anniversary celebration',
    subtitle: 'Celebrate your special milestone with an elegant evening featuring romantic decorations, gourmet dining, and personalized touches.',
    link: '/branches',
    buttonText: 'Book Now'
  },
  {
    id: 4,
    image: '/images/image6.jpeg',
    title: 'Family & friends gathering',
    subtitle: 'Create lasting memories with loved ones in our spacious venues perfect for family reunions and friendly get-togethers.',
    link: '/branches',
    buttonText: 'Book Now'
  },
  // {
  //   id: 7,
  //   image: '/images/image7.jpg',
  //   title: 'Corporate events',
  //   subtitle: 'Host impressive business meetings, team celebrations, and corporate gatherings with professional amenities and catering services.',
  //   link: '/branches',
  //   buttonText: 'Book Corporate Event'
  // },
  {
    id: 5,
    image: '/images/image8.jpeg',
    title: 'Baby shower',
    subtitle: 'Celebrate new beginnings with a beautiful baby shower featuring custom themes, games, and special arrangements for the mom-to-be.',
    link: '/branches',
    buttonText: 'Book Now'
  },
  {
    id: 6,
    image: '/images/image9.jpeg',
    title: 'Graduation party',
    subtitle: 'Mark academic achievements with a memorable celebration in our versatile venues with custom decorations and catering options.',
    link: '/branches',
    buttonText: 'Book Now'
  }
  // {
  //   id: 10,
  //   image: '/gallery/image1.JPG',
  //   title: 'Kitty party',
  //   subtitle: 'Host the perfect ladies get-together with themed decorations, entertainment, and specially curated menu options.',
  //   link: '/branches',
  //   buttonText: 'Plan Kitty Party'
  // }
];

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 6000);

    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => {
    if (isAnimating) return;
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    if (isAnimating) return;
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="relative overflow-hidden h-[90vh] w-full bg-black">
      {/* Elegant top border */}
      <div className="absolute top-0 left-0 right-0 z-40 h-1 bg-gradient-to-r from-primary via-secondary to-accent"></div>
      
      {/* Slide counter - simplified */}
      <div className="absolute top-6 right-6 z-40 flex items-center space-x-4">
        <div className="bg-black/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-white font-medium text-xs border border-white/10">
          {String(currentSlide + 1).padStart(2, '0')} / {String(slides.length).padStart(2, '0')}
        </div>
      </div>
      
      <AnimatePresence initial={false} mode="sync" onExitComplete={() => setIsAnimating(false)}>
        <motion.div
          key={currentSlide}
          initial={{ opacity: 0, scale: 1.05 }}
          animate={{ 
            opacity: 1,
            scale: 1,
            transition: {
              opacity: { duration: 0.7 },
              scale: { duration: 6 }
            }
          }}
          exit={{ 
            opacity: 0,
            transition: { duration: 0.5 }
          }}
          onAnimationStart={() => setIsAnimating(true)}
          className="absolute inset-0"
        >
          {/* Background image with overlay */}
          <div className="absolute inset-0 overflow-hidden">
            <motion.img
              src={slides[currentSlide].image}
              alt={slides[currentSlide].title}
              className="w-full h-full object-cover"
            />
            {/* Simplified gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/50 to-transparent" />
            <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent" />
            <div className="absolute inset-0 bg-primary/10" />
          </div>
          
          {/* Content container */}
          <div className="relative h-full flex items-center">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
              <motion.div 
                className="max-w-xl lg:max-w-3xl md:ml-12 lg:ml-20 z-20"
                initial={{ y: 30, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: -30, opacity: 0 }}
                transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
              >
                {/* Experience tag */}
                <div className="inline-block px-4 py-1.5 rounded-lg bg-secondary/20 border border-secondary/30 shadow-sm mb-4">
                  <p className="text-sm font-medium text-secondary">Exceptional Experiences</p>
                </div>
                
                {/* Title with simplified design */}
                <h1 className="text-5xl md:text-7xl font-display font-bold text-white mb-6 tracking-tight">
                  {slides[currentSlide].title}
                </h1>
                
                <p className="text-base md:text-xl text-white/80 mb-8 max-w-lg leading-relaxed">
                  {slides[currentSlide].subtitle}
                </p>
                
                {/* Cleaner CTA buttons */}
                <div className="flex flex-wrap gap-4 mt-8">
                  <Link
                    to={slides[currentSlide].link}
                    className="inline-flex items-center px-8 py-4 text-base font-bold rounded-lg bg-secondary text-primary-900 hover:bg-secondary-light transition-all duration-300 shadow-lg transform hover:-translate-y-1"
                  >
                    <span>{slides[currentSlide].buttonText}</span>
                    <FiArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} />
                  </Link>
                  
                  <Link
                    to="/branches"
                    className="inline-flex items-center px-8 py-4 text-base font-medium rounded-lg border border-white/30 text-white hover:bg-white/10 transition-all duration-300"
                  >
                    Explore Theatres
                  </Link>
                </div>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </AnimatePresence>
      
      {/* Simplified navigation indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-40 flex space-x-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
            className={`h-2 rounded-full transition-all duration-300 ${
              index === currentSlide 
                ? 'w-8 bg-secondary' 
                : 'w-2 bg-white/30 hover:bg-white/50'
            }`}
          />
        ))}
      </div>
      
      {/* Clean navigation arrows */}
      <button
        className="absolute left-4 md:left-6 top-1/2 transform -translate-y-1/2 z-30 h-10 w-10 rounded-full bg-black/30 backdrop-blur-sm border border-white/10 text-white hover:bg-secondary hover:text-primary-900 transition-all duration-300 flex items-center justify-center"
        onClick={prevSlide}
        aria-label="Previous slide"
      >
        <FiChevronLeft size={20} />
      </button>
      <button
        className="absolute right-4 md:right-6 top-1/2 transform -translate-y-1/2 z-30 h-10 w-10 rounded-full bg-black/30 backdrop-blur-sm border border-white/10 text-white hover:bg-secondary hover:text-primary-900 transition-all duration-300 flex items-center justify-center"
        onClick={nextSlide}
        aria-label="Next slide"
      >
        <FiChevronRight size={20} />
      </button>
    </div>
  );
};

export default HeroSlider; 